import { JobSiteModel } from "@fs/models/customer/job-site-detail-model";
import { CodeTypeModel } from "@fs/models/code-type.model";
import { PromisedTimeModel } from "@fs/models/promised-time.model";
import { BillingDetailModel, UserModel } from "@fs/models/customer/billing-detail.model";

export class WorkOrderModel{
    ID: string
    JobSite: JobSiteModel
    Customer: BillingDetailModel
    Department: Department
    Status: CodeTypeModel
    SubStatus: CodeTypeModel
    PromisedTime: PromisedTimeModel
    OwnerUser: UserModel
    Priority:WorkTicketPriority
    WorkTicketNo:string
    DispatchComment:string
    RequestedBy:string
    PromisedDate: string
    CustomerPO:string
    Issue:string
    SendAppointmentConfirmation:boolean
    AssignedTechnicians:WorkTicketTechnician[]
    UserAppointments: UserAppointment[];
    WorkTicketPriceBookItems:WorkTicketItem[]
    WorkTicketDiscountItems:any=[];
    WorkTicketItems:WorkTicketItem[]
    WorkTicketDiscountItem:WorkTicketDiscountItem
    WorkTicketPayment:WorkTicketPayment
    IsActive:boolean
    ServiceType:ServiceType
    ModifyDate:string
    Attachments:any
    Duration:string
    CompletedDate:string;
    VisitID:string;
    public constructor(){
        this.ID="",
        this.AssignedTechnicians = [],
        this.WorkTicketPriceBookItems = [],
        this.WorkTicketItems = [],
        this.ModifyDate = "",
        this.Attachments=[],
        this.UserAppointments= [];
        this.CompletedDate = "";
        this.WorkTicketNo = "";
        this.PromisedDate = "";
        this.Status = new CodeTypeModel();
        this.SubStatus = new CodeTypeModel();
        this.Customer = new BillingDetailModel();
        this.JobSite = new JobSiteModel();
        this.ServiceType = new ServiceType();
        this.Department = new Department();
        this.OwnerUser = new UserModel();
        this.PromisedTime = new PromisedTimeModel();
        this.WorkTicketPayment= new WorkTicketPayment();
    } 
}
export class Department{
    ID:string;
    Name:string;
    Description:string
}

export class WorkTicketPriority{
    ID:string;
    Name:string;
    Description:string
}

export class WorkTicketTechnician{
    PromisedDate:string;
    User:UserModel;
    StartTime:string;
    EndTime:string;
    IsPrimary:boolean;
    IsDirty:boolean;
    ID:string;
}
export class UserAppointment
{
    ID: string;
    UserID: string;
    AppointmentTypeID: string;
    AppointmentDate:string;
    StartTime: string;
    EndTime: string;
    Note: string;
    WorkTicketID: string;
    StatusID:string;
    SubStatusID:string;
    ModifyDate: string;
    IsSchedule : boolean;
    IsDirty: boolean;
    public constructor()
    {
        this.ID = '';
        this.UserID = '';
        this.AppointmentTypeID = '';
        this.AppointmentDate ='';
        this.StartTime = '';
        this.EndTime = '';
        this.Note = '';
        this.WorkTicketID = '';
        this.StatusID ='';
        this.SubStatusID ='';
        this.ModifyDate = '';
        this.IsSchedule = false;
        this.IsDirty = false;
    }

}
export class WorkTicketItem{
    ID:string;
    Quantity:string;
    WorkTicket:WorkOrderModel;
    Note:string
    Status: CodeTypeModel
}

export class WorkTicketPayment{
    TotalApprovedPrice:string;
    NetTaxable:string;
    TaxGroup:any;
    TaxedAmount:string;
    TaxID:string
    TotalPaid: string
    AppliedCredit:string
    CustomerSignImgUrl:string;
    TechnicianSignImgUrl:string;
    SignatureDateTime:Date;
    InvoiceComment:string;
    CustomerSignText:string;
    WorkTicketPaidDetails:any=[];
    WorkTicketPayment:WorkTicketPaidDetails[];
    Total:Number;
}

export class WorkTicketPaidDetails{
    PaymentType:CodeTypeModel;
    DateTime:Date;
    PaymentDetails:string;
    Amount:string
    EndTotalPayment: string
    Issue:string  
}

export class ServiceType{
    ID:string;
    Name:string;
}

export class WorkTicketDiscountItem{
    ID: string
    Discount: Discount
    Name: string 
    Rate?: number = 0;
    DiscountType: any
    IsDirty: boolean = false
    IsDeleted: boolean = false
    IsCustom: boolean = false
    WorkTicketPriceBookItemIDs: any = []
}

export class Discount{
    ID: string
    Name: string
    DiscountType: any
    Amount: number
    IsAmountEditable: boolean
    IsNameEditable: boolean
}

export class WorkTicketPaymentSummary {
    
    private _isApprovedAmountNegative : boolean;
    public get IsApprovedAmountNegative() : boolean {
        return this._isApprovedAmountNegative;
    }    
    

    /*** Total Approved Amount*/
    private _totalApproved : number;
    public get TotalApproved() : number {
        return this._totalApproved;
    }
    public set TotalApproved(v : number) {
        this._totalApproved = v;
        this._isApprovedAmountNegative=this._totalApproved < 0
    }
    


    /***Total Payable amount */
    TotalAmount: number;
    /***Pending Amount After Paying*/
    BalanceOwed: number;
    /***Discounted Price*/
    DiscountAmount: number;
    /*** Taxable Amount*/
    NetTaxable:number;
    /*** Taxed Amount*/
    TaxedAmount:number;

    TotalPaid:number;

    constructor() {
        this.TotalAmount = 0;
        this.BalanceOwed = 0;
        this.DiscountAmount = 0;
        this.NetTaxable=0;
        this.TotalApproved=0;
        this.TaxedAmount=0;
        this.TotalPaid=0;
    }
}

export class WorkTicketPriceBookItemEquipment {
  public ID: string
  public WorkticketPriceBookItemID: string
  public JobSiteEquipmentID: string
  public JobSiteEquipment: { ID: string}

  constructor(equipId="") {
    this.ID = "";
    this.WorkticketPriceBookItemID = "";
    this.JobSiteEquipmentID = equipId;
    this.JobSiteEquipment = { ID: equipId }
  }
}